import { render, staticRenderFns } from "./InvoiceSettings.vue?vue&type=template&id=5ae31c0c&scoped=true&"
import script from "./InvoiceSettings.vue?vue&type=script&lang=js&"
export * from "./InvoiceSettings.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSettings.vue?vue&type=style&index=0&id=5ae31c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae31c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae31c0c')) {
      api.createRecord('5ae31c0c', component.options)
    } else {
      api.reload('5ae31c0c', component.options)
    }
    module.hot.accept("./InvoiceSettings.vue?vue&type=template&id=5ae31c0c&scoped=true&", function () {
      api.rerender('5ae31c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Tabs/InvoiceSettings.vue"
export default component.exports